import { createSelector } from 'reselect';

const getDone = _ => _.done;
const getMarkers = _ => _.markers;
const getCollectibles = (_, collectibles) => collectibles;

const sortByCategory = (a, b) => {
  if (a.category > b.category) return 1;
  if (a.category < b.category) return -1;
  return 0;
};

const groupByCategory = (acc, obj) => {
  const prev = acc[obj.category] || 0;
  return { ...acc, [obj.category]: prev + 1 };
};

const filterCollectibles = collectibles => ([key]) =>
  collectibles.includes(key);

const filterMarkersChecked = dones => obj => dones.includes(obj.id);

const getCategoriesScore = createSelector(
  getMarkers,
  getDone,
  getCollectibles,
  (markers, dones, collectibles) => {
    const checked = markers.filter(filterMarkersChecked(dones));
    const counts = checked.sort(sortByCategory).reduce(groupByCategory, {});
    const totals = markers.sort(sortByCategory).reduce(groupByCategory, {});
    return Object.entries(totals)
      .filter(filterCollectibles(collectibles))
      .reduce((acc, [key, total]) => {
        const count = counts[key];
        const next = { count, total };
        return { ...acc, [key]: next };
      }, {});
  }
);

export default getCategoriesScore;
